import * as types from './types';
import { loading, error } from 'State/actions';
import { getGradesAction } from 'State/grades/actions';
import { getSitesAction } from 'State/sites/actions';
import { getLanguagesAction } from 'Pages/importstudents/state/actions';
import { toastSuccess } from 'Common/ToastHelper';

export const clearErrors = () => {
  return error(types.POWERSCHOOL_INTEGRATION_CLEAR_ERROR, null);
};

export const addLanguageMappingDataAction = data => {
  return {
    type: types.POWERSCHOOL_ADD_LANGUAGE_MAPPING_DATA,
    payload: data,
  };
};

export const getData = () => async (dispatch, getState, MPWWebApi) => {
  dispatch(loading(types.POWERSCHOOL_INTEGRATION_FETCHING, true));

  await Promise.all([
    dispatch(getConfiguration()),
    dispatch(getGradesAction()),
    dispatch(getSitesAction()),
    dispatch(getLanguagesAction()),
  ]);

  dispatch(loading(types.POWERSCHOOL_INTEGRATION_FETCHING, false));
};

export const getConfiguration = () => async (dispatch, getState, MPWWebApi) => {
  try {
    const response = await MPWWebApi.getGeneric(
      `sisintegration/powerschool/configuration`
    );

    dispatch({
      type: types.POWERSCHOOL_INTEGRATION_SET_CONFIGURATION,
      payload: response.data.Data,
    });
  } catch (error) {
    dispatch({
      type: types.POWERSCHOOL_INTEGRATION_ERROR,
      payload: error,
    });
  }
};

export const storeConfiguration = configuration => async (
  dispatch,
  getState,
  MPWWebApi
) => {
  try {
    dispatch(loading(types.POWERSCHOOL_INTEGRATION_LOADING, true));

    await MPWWebApi.postGenericInsertUpdate(
      `sisintegration/powerschool/configuration`,
      configuration
    );

    toastSuccess('Configuration saved.');

    dispatch({
      type: types.POWERSCHOOL_INTEGRATION_SET_CONFIGURATION,
      payload: configuration,
    });

    dispatch(loading(types.POWERSCHOOL_INTEGRATION_LOADING, false));
  } catch (error) {
    dispatch({
      type: types.POWERSCHOOL_INTEGRATION_ERROR,
      payload: error,
    });

    dispatch(loading(types.POWERSCHOOL_INTEGRATION_LOADING, false));
  }
};



// WEBPACK FOOTER //
// ./src/pages/powerschoolintegration/state/powerschool/actions.js